import React, { SVGProps } from 'react';
import styled, { css } from 'styled-components';
import { getIcon } from 'bench-style-constants';

export const iconSizeMap = {
  small: {
    icon: '16px',
    margin: '4px',
  },
  medium: {
    icon: '24px',
    margin: '6px',
  },
  large: {
    icon: '32px',
    margin: '8px',
  },
};
const StyledIcon = styled.svg<IconProps>`
  width: ${({ size = 'medium' }) => iconSizeMap[size].icon};
  height: ${({ size = 'medium' }) => iconSizeMap[size].icon};
  ${({ margin, size = 'medium' }) =>
    margin === 'left' &&
    css`
      margin-left: ${iconSizeMap[size].margin};
    `} ${({ margin, size = 'medium' }) =>
    margin === 'right' &&
    css`
      margin-right: ${iconSizeMap[size].margin};
    `};
`;

type IconProps = SVGProps<any> & {
  icon: string;
  size?: 'small' | 'medium' | 'large';
  margin?: 'left' | 'right' | null;
  viewBox?: string;
};

const Icon = ({ icon: iconName, viewBox, ...props }: IconProps) => {
  const icon = getIcon(iconName);
  const accessibilityAttributes = icon.title && {
    ariaDescribedBy: iconName,
    role: 'img',
  };
  return (
    <StyledIcon
      {...props}
      {...accessibilityAttributes}
      xmlns="http://www.w3.org/2000/svg"
      viewBox={viewBox}
    >
      {icon.title && <title id={iconName}>{icon.title}</title>}
      <path d={icon.path} />
    </StyledIcon>
  );
};

Icon.defaultProps = {
  size: 'medium',
  margin: null,
  viewBox: '0 0 24 24',
};
export default Icon;
